import { createReducer, combineReducers } from "@reduxjs/toolkit";

import { payloadReducer } from "core/redux/reducer-helpers";

import { onRandomScramble } from "./actions";
import { RandomScrambleState } from "./types";

export default combineReducers<RandomScrambleState>({
  scramble: createReducer<RandomScrambleState["scramble"]>("", (builder) => {
    builder.addCase(onRandomScramble, payloadReducer);
  }),
});
